// Single source of truth for every PageTabs array used across Course, Learning Path,
// Users, and Settings detail pages. Don't hand-roll these arrays in individual page
// files — that's how tabs ended up showing on some pages and not others.

export const buildCourseTabs = (id, { permissions = [], roleId } = {}) => {
  if (!id) return [];
  return [
    { label: 'Preview', to: `/course/preview/${id}` },
    permissions.includes('enroll_learners_course') && { label: 'Learners', to: `/course/learners/${id}` },
    permissions.includes('edit_course') && { label: 'Edit Course', to: `/course/form/${id}` },
    (permissions.includes('edit_course') || permissions.includes('manage_settings')) &&
      { label: 'Settings', to: `/course/settings/${id}` },
    (roleId === 1 || roleId === 7) && { label: 'Feedback', to: `/course/l1-feedback/${id}` },
    roleId === 1 && { label: 'Feedback Settings', to: `/settings/feedback-settings/${id}` },
  ].filter(Boolean);
};

export const buildLPathTabs = (id, { permissions = [], roleId } = {}) => {
  if (!id) return [];
  return [
    { label: 'Preview', to: `/learning_path/preview/${id}` },
    permissions.includes('edit_learning_path') && { label: 'Edit', to: `/learning_path/form/${id}` },
    permissions.includes('edit_learning_path') && { label: 'Courses & Paths', to: `/learning_path/contents/${id}` },
    permissions.includes('edit_learning_path') && { label: 'Settings', to: `/learning_path/settings/${id}` },
    permissions.includes('enroll_learner_lp') && { label: 'Learners', to: `/learning_path/learners/${id}` },
    (roleId === 1 || roleId === 7) && { label: 'Feedback', to: `/learning_path/l1-feedback/${id}` },
    roleId === 1 && { label: 'Feedback Settings', to: `/learning_path/feedback-settings/${id}` },
  ].filter(Boolean);
};

export const USERS_TABS = [
  { label: 'Users',       to: '/users',       match: '/users', exact: true },
  { label: 'Cohorts',     to: '/groups',      match: '/groups' },
  { label: 'Job Roles',   to: '/job-roles',   match: '/job-roles' },
  { label: 'Purge Users', to: '/users/purge', match: '/users/purge' },
];

export const SETTINGS_TABS = [
  { label: 'General',         to: '/settings/generalSettings' },
  { label: 'Feedback',        to: '/settings/feedback' },
  { label: 'Email Templates', to: '/settings/emailSettings' },
  { label: 'Embed',           to: '/settings/embedded' },
];